<script>
export default {
  data() {
    return {
      isPasswordVisible: false,
      FridayOne: ["Select", "Black Friday", "Valentines"],
      InteriorSel: ["Select", "Car Repair", "Interior Designing", "House Cleaning"],
      CouponType: ["Select", "Percentage", "Fixed"],
      EditFridayOne: ["Select", "Black Friday", "Valentines"],
      EditInteriorSel: ["Select", "Car Repair", "Interior Designing", "House Cleaning"],
      EditCouponType: ["Select", "Percentage", "Fixed"],
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
    submitForm() {
      this.$router.push("/provider/provider-coupons");
    },
  },
};
</script>
<template>
  <!-- Add coupons -->
  <div class="modal fade custom-modal" id="add-coupons">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-0"
        >
          <h5>Add Coupon</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Services</label>
                  <vue-select
                    :options="InteriorSel"
                    id="interiorsel"
                    placeholder="Select"
                  />
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Coupon Name</label>
                      <input type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Code</label>
                      <input type="text" class="form-control" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Coupon Type</label>
                      <vue-select
                        :options="CouponType"
                        id="coupontype"
                        placeholder="Select"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Discount</label>
                      <div class="input-icon position-relative">
                        <span class="input-icon-addon"
                          ><i class="ti ti-square-rounded-percentage"></i
                        ></span>
                        <input type="text" class="form-control" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Start Date</label>
                      <div class="input-icon position-relative">
                        <span class="input-icon-addon"
                          ><i class="ti ti-calendar"></i
                        ></span>
                        <date-picker
                          v-model="startdate"
                          placeholder=""
                          class="datetimepicker form-control"
                          :editable="true"
                          :clearable="false"
                          :input-format="dateFormat"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">End Date</label>
                      <div class="input-icon position-relative">
                        <span class="input-icon-addon"
                          ><i class="ti ti-calendar"></i
                        ></span>
                        <date-picker
                          v-model="startdateOne"
                          placeholder=""
                          class="datetimepicker form-control"
                          :editable="true"
                          :clearable="false"
                          :input-format="dateFormat"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row align-items-center justify-content-center">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Company Name</label>
                      <vue-select
                        :options="FridayOne"
                        id="fridayone"
                        placeholder="Select"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex align-items-center justify-content-center">
                      <div class="form-check form-switch d-flex align-items-center">
                        <input
                          class="form-check-input me-1"
                          type="checkbox"
                          role="switch"
                          id="switch-sm"
                          checked
                        />
                        <h6 class="fs-14">Once per Customer</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="d-flex flex-column">
                      <label class="form-label">End Date</label>
                      <div class="d-flex">
                        <div class="form-check me-2">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault1"
                          />
                          <label class="form-check-label" for="flexRadioDefault1">
                            Active
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault2"
                            checked
                          />
                          <label class="form-check-label" for="flexRadioDefault2">
                            Inactive
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <button type="button" class="btn bg-gray" data-bs-dismiss="modal">
            Cancel
          </button>
          <button type="button" class="btn btn-dark">Submit</button>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add coupons -->

  <!--Edit coupons -->
  <div class="modal fade custom-modal" id="edit-coupons">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-0"
        >
          <h5>Edit Coupon</h5>
          <a href="#" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Services</label>
                  <vue-select
                    :options="EditInteriorSel"
                    id="editinteriorsel"
                    placeholder="Interior Designing"
                  />
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Coupon Name</label>
                      <input type="text" class="form-control" value="Black Friday" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Code</label>
                      <input type="text" class="form-control" value="GIFTGUIDE" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Coupon Type</label>
                      <vue-select
                        :options="EditCouponType"
                        id="editcoupontype"
                        placeholder="Percentage"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Discount</label>
                      <div class="input-icon position-relative">
                        <span class="input-icon-addon"
                          ><i class="ti ti-square-rounded-percentage"></i
                        ></span>
                        <input type="text" class="form-control" value="5%" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Start Date</label>
                      <div class="input-icon position-relative">
                        <span class="input-icon-addon"
                          ><i class="ti ti-calendar"></i
                        ></span>
                        <date-picker
                          v-model="startdate"
                          placeholder=""
                          class="datetimepicker form-control"
                          :editable="true"
                          :clearable="false"
                          :input-format="dateFormat"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">End Date</label>
                      <div class="input-icon position-relative">
                        <span class="input-icon-addon"
                          ><i class="ti ti-calendar"></i
                        ></span>
                        <date-picker
                          v-model="startdateOne"
                          placeholder=""
                          class="datetimepicker form-control"
                          :editable="true"
                          :clearable="false"
                          :input-format="dateFormat"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row align-items-center justify-content-center">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Company Name</label>
                      <vue-select
                        :options="EditFridayOne"
                        id="editfridayone"
                        placeholder="Select"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex align-items-center justify-content-center">
                      <div class="form-check form-switch d-flex align-items-center">
                        <input
                          class="form-check-input me-1"
                          type="checkbox"
                          role="switch"
                          id="switch-sm"
                          checked
                        />
                        <h6 class="fs-14">Once per Customer</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="d-flex flex-column">
                      <label class="form-label">End Date</label>
                      <div class="d-flex">
                        <div class="form-check me-2">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault3"
                          />
                          <label class="form-check-label" for="flexRadioDefault3">
                            Active
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault4"
                            checked
                          />
                          <label class="form-check-label" for="flexRadioDefault4">
                            Inactive
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <button type="button" class="btn bg-gray" data-bs-dismiss="modal">
            Cancel
          </button>
          <button type="button" class="btn btn-dark">Submit</button>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit coupons -->

  <!-- Delete Staff -->
  <div class="modal fade custom-modal" id="del-coupons">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete coupons</h5>
          <a href="#" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <div class="modal-body">
          <div class="write-review">
            <form @submit.prevent="submitForm">
              <p>Are you sure want to delete this coupons?</p>
              <div class="modal-submit text-end">
                <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal">Cancel</a>
                <button type="submit" class="btn btn-dark">Yes</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Staff -->

  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form action="#">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">Delete Account</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Delete Account -->
</template>
